import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Alert,
} from "@mui/material";
import httpRequest from "../utils/httpRequest";

const ServiceLocations = () => {
  const [serviceLocations, setServiceLocations] = useState([]);
  const [newLocation, setNewLocation] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  const fetchServiceLocations = async () => {
    try {
      const data = await httpRequest("service-location/", "GET");
      setServiceLocations(data || []);
    } catch (error) {
      console.error("Error fetching service locations:", error);
    }
  };

  const handleAddLocation = async () => {
    if (!newLocation.trim()) return;

    try {
      await httpRequest("service-location/", "POST", { location: newLocation.trim() });
      setSnackbar({ open: true, message: "Service location added!", severity: "success" });
      setNewLocation("");
      setOpenDialog(false);
      fetchServiceLocations();
    } catch (error) {
      setSnackbar({ open: true, message: "Failed to add location.", severity: "error" });
      console.error("Error adding location:", error);
    }
  };

  useEffect(() => {
    fetchServiceLocations();
  }, []);

  return (
    <Container sx={{ mt: 4 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h4">Service Locations</Typography>
        <Button variant="contained" onClick={() => setOpenDialog(true)}>
          Add Location
        </Button>
      </Box>

      <TableContainer component={Paper} elevation={3} sx={{ mt: 2, borderRadius: 2 }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>S.No.</TableCell>
              <TableCell>Mandi</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {serviceLocations.map((location, index) => (
              <TableRow key={index} hover>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{location.location}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Add Service Location</DialogTitle>
        <DialogContent>
          <TextField
            label="Location"
            value={newLocation}
            onChange={(e) => setNewLocation(e.target.value)}
            fullWidth
            autoFocus
            sx={{ mt: 1 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleAddLocation}>
            Add
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity={snackbar.severity} onClose={() => setSnackbar({ ...snackbar, open: false })}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default ServiceLocations;